/**
 * Chrome and Edge change the value of a focused <input type="number"> when the
 * user scrolls the wheel over it: scrolling the page past a price or capacity
 * field silently saves a different number. Taking the focus off the input
 * before the browser handles the wheel keeps the value and lets the page scroll.
 * Arrow keys still step the value, which is a deliberate action.
 */
const handleWheel = e => {
  const target = e.target;
  if (target && target.type === 'number' && target === document.activeElement) {
    target.blur();
  }
};

export const preventNumberInputWheelChange = () => {
  document.addEventListener('wheel', handleWheel, { passive: true });
};
